<template>
  <PageLayout>
    <component
      v-if="_config"
      :is="
        _config.lotteryHall
          ? _config.lotteryHall.configValue.templateApp || _config.lotteryHall.configValue.template || 'default'
          : 'default'
      "
    />
    <!-- <component v-if="_config" :is="'dafacp'" /> -->
  </PageLayout>
</template>
<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
import PageLayout from '@c/layout/PageLayout'
export default {
  mixins: [appConfigMixins],
  components: {
    PageLayout,
    default: () => import('@t/Lottery/LotteryPurchase'),
    default1: () => import('@t/Lottery/LotteryPurchase'),
    yabo: () => import('@t/Lottery/LotteryPurchaseYabocp'),
    dfcp: () => import('@t/Lottery/LotteryPurchaseDfcp'),
    shop: () => import('@t/Lottery/LotterStop'),
    dafacp: () => import('@t/Lottery/LotteryPurchaseDfcpGc')
  }
}
</script>
<style lang="scss" scope></style>
